module.exports = __webpack_public_path__ + "bg68-split-946d4bd6f73c5e16b57a55391dfff402.png";